/*
 * mocks/api/voicemail.ts
 * Anvilo, Inc.
 *
 * This file contains messages API mocks
 *
 * Created by Artem Yefimenko on 10/08/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import { mock } from "../axios";

const API_URL = "https://testing-webapp-api.talkroute.com/api/";

const GET_THREADS_URL = "desktop/messages/text/threads";
const GET_THREAD_URL = "desktop/messages/text/thread/13317173121-16504519942";
const GET_ATTACHED_IMAGE_1_URL =
  "desktop/messages/text/message/bf73a0af-d18d-11ea-b4e5-56000258b29a/attachment/ba319267-c36c-11ea-b4e5-56000258b29a";

const MAKE_MESSAGE_READ_URL =
  "desktop/messages/text/thread/13317173121-16504519942/read?last_seen_created_at_micro_seconds=1596021732.084";

export const mockedThreads = [
  {
    contact_number: "16504519942",
    conversation_id: "13317173121-16504519942",
    last_message_at: "2020-07-29T11:22:12+0000",
    talkroute_number: "13317173121",
    last_message: {
      body: "",
      contact_number: "16504519942",
      created_at: "2020-07-29T11:22:12+0000",
      created_at_micro_seconds: 1596021732.084,
      id: "bf73a0af-d18d-11ea-b4e5-56000258b29a",
      is_last_message: true,
      message_direction: "outgoing",
      read: false,
      talkroute_number: "13317173121",
      updated_at: "2020-07-29T11:22:12+0000",
      user_email: "velgenov@gmail.com",
      attachments: [
        {
          id: "ba319267-c36c-11ea-b4e5-56000258b29a",
          file_type: "image",
          image_info: {
            original: {
              width: 700,
              height: 525,
            },
            medium: {
              width: 399,
              height: 300,
            },
          },
        },
      ],
    },
  },
];

export const mockedThread = {
  conversation_id: "13317173121-16504519942",
  talkroute_number: "13317173121",
  contact_number: "16504519942",
  pagination: {
    limit: 25,
    offset: 0,
    count: 2,
    timestamp: 1596107896,
  },
  messages: [
    {
      id: "bf73a0af-d18d-11ea-b4e5-56000258b29a",
      body: "",
      attachments: [
        {
          id: "ba319267-c36c-11ea-b4e5-56000258b29a",
          file_type: "image",
          image_info: {
            original: {
              width: 700,
              height: 525,
            },
            medium: {
              width: 399,
              height: 300,
            },
          },
        },
      ],
      read: false,
      created_at_micro_seconds: 1594468233.5702,
      is_last_message: false,
      created_at: "2020-07-11T11:50:33+0000",
      updated_at: "2020-07-11T11:50:33+0000",
      user_email: "velgenov@gmail.com",
      talkroute_number: "13317173121",
      contact_number: "16504519942",
      message_direction: "outgoing",
    },
  ],
};

mock.onGet(new RegExp(`${API_URL}${GET_THREADS_URL}\w*`)).reply((request) => {
  return [
    200,
    {
      pagination: {
        count: 1,
        limit: 25,
        offset: 0,
        timestamp: 1596106766,
      },
      threads: mockedThreads,
    },
  ];
});

mock.onGet(`${API_URL}${GET_THREAD_URL}`).reply((request) => {
  return [200, mockedThread];
});

mock.onPost(`${API_URL}${MAKE_MESSAGE_READ_URL}`).reply(async (request) => {
  return [200, {}];
});

mock.onGet(`${API_URL}${GET_ATTACHED_IMAGE_1_URL}`).reply(async (request) => {
  const jestMockImage =
    "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFhAJ/wlseKgAAAABJRU5ErkJggg==";
  const imageUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/resources/mock/images/cbimage.jpg`;
  const testImage = process.env.JEST_WORKER_ID
    ? Buffer.from(jestMockImage, "base64")
    : Buffer.from(await (await fetch(imageUrl)).arrayBuffer());
  return [200, testImage, { "content-type": "image/jpeg" }];
});
